/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_success_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey registered successfully!`)
};

const zh_hans1_settings_success_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通行密钥注册成功！`)
};

const zh_hant1_settings_success_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已註冊通行金鑰`)
};

const fr_settings_success_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey enregistré avec succès !`)
};

const de_settings_success_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey erfolgreich registriert!`)
};

const ja_settings_success_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーを登録しました！`)
};

const ko_settings_success_passkey_registered = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`패스키가 등록되었습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_success_passkey_registered = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_success_passkey_registered(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_success_passkey_registered", locale)
	if (locale === "en") return en_settings_success_passkey_registered(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_success_passkey_registered(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_success_passkey_registered(inputs)
	if (locale === "fr") return fr_settings_success_passkey_registered(inputs)
	if (locale === "de") return de_settings_success_passkey_registered(inputs)
	if (locale === "ja") return ja_settings_success_passkey_registered(inputs)
	return ko_settings_success_passkey_registered(inputs)
};